const MCP_AUTHORIZE_PATH = '/mcp/authorize';

const MCP_ERROR_KEYS: Record<string, string> = {
	none: 'errors.users.loginNotFound',
	many: 'mcp.authorize.manyWorkspaces',
	disabled: 'mcp.authorize.disabled',
};

export function isMcpAuthorizePath(pathname: string): boolean {
	return pathname === MCP_AUTHORIZE_PATH;
}

export function mcpAuthorizeErrorKey(error: string | null): string | undefined {
	if (!error) {
		return undefined;
	}
	return MCP_ERROR_KEYS[error];
}

export function mcpAuthorizeContinueUrl(apiOrigin: string, search: string, email: string): string {
	const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
	params.delete('error');
	params.set('login_hint', email.trim());
	return `${apiOrigin.replace(/\/$/, '')}/oauth/authorize?${params.toString()}`;
}
